var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SharedModule } from './../../components/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AuthComponent } from './auth.component';
import { AuthService } from './auth.service';
var Auth0Module = (function () {
    function Auth0Module() {
    }
    Auth0Module = __decorate([
        NgModule({
            imports: [CommonModule, FormsModule, SharedModule],
            declarations: [AuthComponent],
            exports: [AuthComponent],
            providers: [AuthService]
        })
    ], Auth0Module);
    return Auth0Module;
}());
export { Auth0Module };
//# sourceMappingURL=auth.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/auth.module.js
// module id = 813
// module chunks = 0